import { IconLoader2 } from "@tabler/icons-react";

export const Spinner = ({
  text = "Loading...",
  size = 20,
  className = "",
  iconClassName = "",
}) => {
  return (
    <div
      className={`flex items-center justify-center gap-2 text-[#8898b5] ${className}`}
    >
      <IconLoader2 className={`animate-spin ${iconClassName}`} size={size} />
      {text}
    </div>
  );
};
